import { externalURLValidation, FormField, getAssetTypeLabel, IAssetMetadata, isUser, SOURCE_TYPE, trackEvent, useUser } from "@desp-aas/desp-ui-fwk";
import { IAssetTabProps, checkFieldHasUpdates, checkMetadataFieldHasUpdates, defaultNullPlaceholder } from "../common";
import { EditableFormField } from "../../../components/EditableFormField/EditableFormField";
import { useCallback, useMemo } from "react";
import './Overview.css';
import { FaChevronRight } from "react-icons/fa6";
import { icons } from "../../../utils/icons";
import { Link } from "react-router-dom";
import classNames from "classnames";
export const Overview = (props: IAssetTabProps) => {

    const onUpdate = useCallback((updates: Partial<IAssetMetadata>)=>{ 
        props.updateAsset({ metadata: {...props.asset.metadata, ...updates } }) 
    }, [ props.asset ])

    const user = useUser();

    const externalURLHasBeenUpdated = useMemo(() => {
        if(!props.editMode) return false;
        if(props.assetResponse?.public && props.assetResponse?.draft){
            return checkMetadataFieldHasUpdates(props.assetResponse?.public, props.assetResponse?.draft, 'externalURL')
        }
    }, [ props.assetResponse, props.editMode ])

    const descriptionHasBeenUpdated = useMemo(() => {
        if(!props.editMode) return false;
        if(props.assetResponse?.public && props.assetResponse?.draft){
            return checkMetadataFieldHasUpdates(props.assetResponse?.public, props.assetResponse?.draft, 'description')
        }
    }, [ props.assetResponse, props.editMode ])
    
    return (
        <>
            <h2>About {getAssetTypeLabel(props.asset.type)}</h2>

            {
                props.asset.source == SOURCE_TYPE.external &&
                <div id="asset-external-container">
                    {
                        props.asset.metadata?.externalURL &&
                        <Link
                            id="asset-external-link"
                            className="button rounded inverted external-link"
                            to={props.asset.metadata.externalURL}
                            target="_blank"
                            onClick={()=>{
                                if(!isUser(user, props.asset.despUserId)){
                                    trackEvent('asset_external_link_viewed', 'asset_external_link_viewed', 'Asset external link viewed')
                                }
                            }}
                        >
                            { icons.externalLink }
                            View external link
                            <span className="chevron">
                                <FaChevronRight/>
                            </span>
                        </Link>
                    }
                    {
                        props.editMode &&
                        <EditableFormField
                            value={props.asset.metadata?.externalURL}
                            placeholder={props.editMode ? `Tell us something about the ${getAssetTypeLabel(props.asset.type)}` : defaultNullPlaceholder}
                            onEnter={(externalURL)=>onUpdate({ externalURL })}
                            onUpdate={(externalURL)=>onUpdate({ externalURL })}
                            confirmBeforeUpdate
                            disabledEditable={!props.editMode}
                            validation={externalURLValidation}
                            notNull
                            editableFormFieldClassName={classNames({ "updated": externalURLHasBeenUpdated })}
                            // id="asset-description"
                        />
                    }
                </div>
            }
            <div id="asset-description">
                <EditableFormField
                    value={props.asset.metadata?.description}
                    // textArea={{
                    //     textAreaProps: {
                    //     }
                    // }}
                    richText={{}}
                    placeholder={props.editMode ? `Tell us something about the ${getAssetTypeLabel(props.asset.type)}` : defaultNullPlaceholder}
                    onEnter={(description)=>onUpdate({ description })}
                    onUpdate={(description)=>onUpdate({ description })}
                    confirmBeforeUpdate
                    disabledEditable={!props.editMode}
                    editableFormFieldClassName={classNames({ "updated": descriptionHasBeenUpdated })}
                    // id="asset-description"
                />
            </div>
        </>
    )
}
export default Overview;